import { Link, useOutletContext } from "react-router-dom";
import Image from "react-bootstrap/esm/Image";
import RowContent from "../../components/containers/row-content";
import SEO from "../../components/seo";

const DevMoviesPage = () => {

    const [jsonData] = useOutletContext();
    const moviesWithImages = jsonData.filmesEmDesenvolvimento ?? [];
    
    return (<>
            <SEO
                title="Desenvolvimento"
                description="Conheça os filmes em desenvolvimento da Abdução Filmes."
                path="/em-desenvolvimento"
            />
            <div className="bg-dark page-fill-main">
                <div className="container">
                    <RowContent className="g-4">
                {moviesWithImages
                .filter(movie => movie.image !== null)
                .map((movie) =>
                    <div className="col-12 col-xs-6 col-sm-6 col-md-4 col-lg-3 small-logo-wrapper" key={movie.path}>
                        <Link relative="true" to={movie.path}>
                            <div className="py-xs-1 text-center movie-card-container position-relative">
                                <Image
                                    src={movie.image}
                                    alt={`Logo do filme ${movie.nome}`}
                                    loading="lazy"
                                    className=" img-fluid pointer small-logo"
                                    style={{minWidth: 150}}
                                    onError={(e) => {
                                        console.error(`Erro ao carregar imagem: ${movie.nome}`);
                                        e.target.style.display = 'none';
                                    }}
                                />
                                <div className="movie-card-overlay d-flex align-items-end justify-content-center">
                                    <span className="text-white fw-bold pb-2 px-2 small text-center">{movie.nome}</span>
                                </div>
                            </div>
                        </Link>
                    </div>
                )}
                    </RowContent>
                </div>
            </div>
        </>
    );
}

export default DevMoviesPage;
